module.exports = __webpack_public_path__ + "56540c96c1f87be608cf77ab6b41671b.svg";